import { defineComponent } from 'vue';
export default defineComponent({
    name: 'BaseLayout',
    setup: function () {
        return {};
    },
});
